




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'BaseIcon',
})
export default class BaseIcon extends Vue {
  @Prop() icon!: string;

  get className() {
    return `svg-icon--${this.icon}`;
  }

  get iconLoader() {
    this.icon; // Needed for reactivity
    return () => import(/* webpackMode: "eager" */ `@lib-ui/assets/icons/${this.icon}.svg`);
  }
}
